<div [ngSwitch]="messageType">
	<div *ngSwitchCase="MsgTypes.ERROR">
		<app-kamona-failure-modal (closeModal)="closeModal()"
								  (emitAction)="continue(MsgTypes.RETRY)"
								  [buttonText]="buttonText"
								  [canShowCancelButton]="canShowCancelButton"
								  [description]="description"
								  [showSuspendedCountDown]="showSuspendedCountDown"
								  [suspensionReleaseTime]="suspensionReleaseTime"
								  [title]="title"
								  [useFullButton]="useFullButton">
		</app-kamona-failure-modal>
	</div>
	<div *ngSwitchCase="MsgTypes.SUCCESS">
		<app-kamona-success-modal (closeModal)="continue(MsgTypes.COMPLETE,savedRes)" [btnText]="buttonText"
								  [description]="description" [title]="title"
								  [useFullButton]="useFullButton">
		</app-kamona-success-modal>
	</div>
	<div *ngSwitchCase="MsgTypes.WARNING">
		<app-kamona-pending-modal (closeModal)="continue(MsgTypes.WARNING,null)"
								  [buttonText]="buttonText" [description]="description"
								  [forNewDevice]="forNewDevice"
								  [canShowCancelButton]="canShowCancelButton"
								  [title]="title" [useFullButton]="useFullButton">
		</app-kamona-pending-modal>
	</div>
</div>
